import { InferenceParameters } from "@/types";

export const getDisplayPrompt = (
  inferenceParameters?: InferenceParameters | null,
): string | undefined => {
  if (inferenceParameters?.multiPrompt?.length) {
    return inferenceParameters.multiPrompt.map((s) => s.prompt).join(" / ");
  }
  return inferenceParameters?.prompt || undefined;
};
